module.exports = __webpack_public_path__ + "1cb88708f7016c9fc671aef3c77b334a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/members/kvaltynova.jpg
// module id = 1243
// module chunks = 0